import React, { useEffect, useState } from 'react';
import { FilterGroup, FilterLabel } from '@lt/components';

import Slider from 'rc-slider';
import classNames from 'classnames';

import styles from './FilterOneSlider.module.css';
import type { FilterOneSliderProps } from './types';
import { secondsToString } from './utils';

export const FilterOneSlider = ({
  data,
  Filter,
  isMobile,
  minPrice,
  onChange,
  onClear,
}: FilterOneSliderProps) => {
  const { suitable_flights, min_duration, max_duration, selected_duration } =
    data;

  const [sliderValue, setSliderValue] = useState(
    selected_duration ?? max_duration,
  );

  const [isClearButtonShown, setClearButtonShown] = useState(false);

  const handleValueChange = (value) => {
    setSliderValue(value);
    setClearButtonShown(true);
  };

  const handleChange = () => {
    onChange({ path: Filter.filterName, selected_duration: sliderValue });
  };

  const handleClear = () => {
    onClear(Filter.filterName);
    setClearButtonShown(false);
    setSliderValue(max_duration);
  };

  useEffect(() => {
    if (!selected_duration) setSliderValue(max_duration);
  }, [max_duration]);

  return (
    <FilterGroup
      label={Filter.filterLabel}
      isCollapsible={!isMobile}
      isMobile={isMobile}
      showClearBtn={isClearButtonShown}
      isClearButtonInline
      onClear={handleClear}
    >
      <FilterLabel
        name={secondsToString(sliderValue)}
        count={suitable_flights}
        isMobile={isMobile}
        price={minPrice}
        className={classNames(styles.label, { [styles.labelMobile]: isMobile })}
      />
      <div
        className={classNames(styles.trackContainer, {
          [styles.trackContainerMobile]: isMobile,
        })}
      >
        <Slider
          min={min_duration}
          max={max_duration}
          value={sliderValue}
          onChange={handleValueChange}
          onChangeComplete={handleChange}
          styles={{
            track: { height: 2, backgroundColor: 'var(--secondary)' },
            rail: {
              backgroundColor: '#FFE6DD',
              height: 2,
            },
            handle: {
              backgroundColor: 'var(--secondary)',
              borderColor: 'var(--secondary)',
              width: 16,
              height: 16,
              marginTop: '-7px',
              opacity: 1,
              boxShadow: 'none',
              border: 'none',
              zIndex: 0,
            },
          }}
        />
      </div>
    </FilterGroup>
  );
};
